import { connect } from 'react-redux';
import {
  getRevenue,
  getRevenueCurrencySymbol,
  getRevenuePayers,
  getRevenueUniqueUsers,
  isRevenueExecuting,
} from '../../reducers/analyticsApp';
import RevenueSummaryPane from '../../components/revenue/RevenueSummaryPane';

const mapStateToProps = (state) => ({
  executing: isRevenueExecuting(state),
  revenue: getRevenue(state),
  payers: getRevenuePayers(state),
  uniqueUsers: getRevenueUniqueUsers(state),
  currencySymbol: getRevenueCurrencySymbol(state),
});

export default connect(mapStateToProps)(RevenueSummaryPane);
